<!-- Modal -->
<!--suppress AngularUndefinedBinding -->
<form [formGroup]="form">
  <div class="modal fade" #modalElm tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'Payment Method' | translate}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
        </div>
        <div class="modal-body">
          <div class="row m-0" *ngIf="newSubAccountRequest">
            <div class="col-12 px-4">
              <div class="d-flex justify-content-between mb-2">
                <p class="textmuted" translate>Qty</p>
                <p class="fs-14 fw-bold">{{newSubAccountRequest.count}} {{newSubAccountRequest.count == 1 ? 'sub-account' : 'sub-accounts' | translate}}</p>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <p class="textmuted" translate>SubTotal</p>
                <p class="fs-14 fw-bold"><span class="fas fa-dollar-sign pe-1"></span>{{(newSubAccountRequest.totalAmount - newSubAccountRequest.totalVatAmount)| number:'1.2-2'}} <span translate>SAR</span></p>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <p class="textmuted" translate>VAT</p>
                <p class="fs-14 fw-bold"><span class="fas fa-dollar-sign pe-1"></span>{{newSubAccountRequest.totalVatAmount | number:'1.2-2'}} <span translate>SAR</span></p>
              </div>
            </div>
            <div class="col-12 px-0">
              <div class="row bg-light m-0" [ngClass]="{'border border-solid border-danger' : submitted && f.paymentVia.errors}">
                <div class="col-12 px-4">
                  <form [formGroup]="form">
                    <h5 class="title p-3 rounded mt-4" [ngClass]="{'font-weight-bold text-danger' : submitted && f.paymentVia.errors}" translate>Choose Payment Method</h5>
                    <div class="pricing p-3 rounded mt-1 d-flex justify-content-between">
                      <div class="images d-flex flex-row align-items-center">
                        <input class="mx-1" type="radio" formControlName="paymentVia" name="paymentVia" value="BankCard"/>
                        <div class="d-flex flex-column">
                          <div class="d-flex flex-row m-1 justify-content-around">
                            <img src="https://payment.paylink.sa/assets/img/master.png" class="rounded" width="40">
                            <img src="https://payment.paylink.sa/assets/img/visa.png" class="rounded" width="40">
                          </div>
                          <div class="d-flex flex-row m-1 justify-content-around">
                            <img src="https://payment.paylink.sa/assets/img/paypall.png" class="rounded" width="40">
                            <img src="https://payment.paylink.sa/assets/img/mada.png" class="rounded" width="40">
                          </div>
                        </div>
                        <div class="d-flex flex-column ml-4">
                          <span class="business" translate>Bank Card</span>
                        </div>
                      </div>
                      <div class="d-flex flex-row align-items-center">
                        <h4 class="amount ml-1 mr-1">{{newSubAccountRequest.totalAmount | number:'1.2-2'}}</h4>
                        <sup class="dollar font-weight-bold" translate>SAR</sup>
                      </div>
                    </div>
                    <div class="pricing p-3 rounded mt-4 d-flex justify-content-between">
                      <div class="images d-flex flex-row align-items-center">
                        <input class="mx-1" type="radio" formControlName="paymentVia" name="paymentVia" value="MerchantWallet"/>
                        <div class="d-flex flex-column">
                          <img src="assets/img/wallet-img.png" class="rounded" width="90">
                        </div>
                        <div class="d-flex flex-column ml-4">
                          <span class="business mb-1" translate>Merchant Wallet</span>
                          <small class="business text-info">{{'Current Balance' | translate}} {{myBusiness.walletAmount | number:'1.2-2'}} <sup translate>SAR</sup></small>
                        </div>
                      </div>
                      <div class="d-flex flex-row align-items-center">
                        <h4 class="amount ml-1 mr-1">{{newSubAccountRequest.totalAmount | number:'1.2-2'}}</h4>
                        <sup class="dollar font-weight-bold" translate>SAR</sup>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- end of modal-body -->
        <div class="modal-footer">
          <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>{{'Close' | translate}}</button>
          <button type="button" (click)="submitPaymentMethod()" class="btn btn-primary" *ngIf="!loading" translate>Pay</button>
          <button type="button" class="btn btn-primary" *ngIf="loading" translate>
            <div class="mx-auto spinner-grow text-dark align-self-center loader-lg"></div>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="modal" #infoModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitle}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{modalMsg}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>
